<div class="m-0 w-100">
  <div class="modal-content">
    <app-modal-header-common title="Balance Scorecard" [dialogRef]="dialogRef">
    </app-modal-header-common>
    <div class="modal-body">
      <app-scorecard-dashboard
        [vendorId]="vendorId"
        pageType="vendorLevel"
      ></app-scorecard-dashboard>
    </div>
    <div class="modal-footer">
      <button mat-button mat-dialog-close>Close</button>
    </div>
  </div>
</div>
